<ng-container *ngIf="showBlocker">
    <div class="oss-mobile-blocker-modal visible-sm" *ngIf="!asUIView">
        <div class="blocker-message-wrapper">
            <div class="blocker-message">
                {{ 'Message.DesktopResolutionTooSmall' | translate }}
            </div>
        </div>
    </div>
    
    <!--Mobile blocker-->
    <div class="c-mobile-blocker__blocker">
        <div class="c-mobile-blocker__overlay" [class.visible-xs]="!asUIView">
            
            <div class="c-mobile-blocker__body">
                <div class="c-mobile-blocker__image-wrapper">
                    <div payAppFlavourClass
                        class="c-mobile-blocker__image"
                    ></div>
                </div>
                
                <div class="d-flex justify-content-center">
                    <div class="c-mobile-blocker__title">
                        {{ title | translate }}
                    </div>
                    <div class="c-mobile-blocker__sub-title">
                        {{ subtitle | translate }}
                    </div>
                </div>
                <div class="c-mobile-blocker__description">
                    <div class="mb-3">
                        {{ description | translate }}
                    </div>
                    <div>
                        {{ descriptionMore | translate }}
                    </div>
                </div>
            </div>
            
            <div class="c-mobile-blocker__footer">
                <div payAppFlavourClass class="c-mobile-blocker__icon"></div>
            </div>
        </div>
    </div>
</ng-container>
